import Headers from "./headers";
import TableBody from "./table_body";

function Table({ headers, items }) {
  return (
    <table className="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
      <Headers headers={headers} />
      <TableBody items={items} />
    </table>
  );
}
export default Table;
